/*
  This is a modified version of the default styling found here:
  https://raw.githubusercontent.com/instructure-react/react-toggle/master/style.css
 */
import styled from '../../config/theme';

const ToggleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 8px;

  .react-toggle {
    touch-action: pan-x;

    display: inline-block;
    position: relative;
    cursor: pointer;
    background-color: transparent;
    border: 0;
    padding: 0;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
  }

  .react-toggle-screenreader-only {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .react-toggle--disabled {
    cursor: not-allowed;
    opacity: 0.5;
    -webkit-transition: opacity 0.25s;
    transition: opacity 0.25s;
  }

  .react-toggle-track {
    width: 50px;
    height: 14px;
    padding: 0;
    border-radius: 30px;
    background-color: #4d4d4d;
    -webkit-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }

  .react-toggle:not(.react-toggle--disabled) {
    .react-toggle-track {
      background-color: ${props => props.theme.toggle.inActiveTrackColor};
    }

    .react-toggle-thumb {
      background-color: ${props => props.theme.toggle.inActiveColor};
    }
  }

  .react-toggle:hover:not(.react-toggle--disabled) {
    .react-toggle-track {
      background-color: ${props => props.theme.toggle.inActiveTrackColor};
    }

    .react-toggle-thumb {
      background-color: ${props => props.theme.toggle.inActiveHoverColor};
    }
  }

  .react-toggle--checked:not(.react-toggle--disabled) {
    .react-toggle-track {
      background-color: ${props => props.theme.toggle.activeTrackColor};
    }

    .react-toggle-thumb {
      background-color: ${props => props.theme.toggle.activeColor};
    }
  }

  .react-toggle--checked:hover:not(.react-toggle--disabled) {
    .react-toggle-track {
      background-color: ${props => props.theme.toggle.activeTrackColor};
    }

    .react-toggle-thumb {
      background-color: ${props => props.theme.toggle.activeHoverColor};
    }
  }

  .react-toggle-track-check {
    position: absolute;
    width: 14px;
    height: 10px;
    top: 0px;
    bottom: 0px;
    margin-top: auto;
    margin-bottom: auto;
    line-height: 0;
    left: 8px;
    opacity: 0;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  .react-toggle--checked .react-toggle-track-check {
    opacity: 1;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  .react-toggle-track-x {
    position: absolute;
    width: 10px;
    height: 10px;
    top: 0px;
    bottom: 0px;
    margin-top: auto;
    margin-bottom: auto;
    line-height: 0;
    right: 10px;
    opacity: 1;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  .react-toggle--checked .react-toggle-track-x {
    opacity: 0;
  }

  .react-toggle-thumb {
    transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
    position: absolute;
    top: -26%;
    left: 0;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: #fafafa;

    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    -webkit-transition: all 0.25s ease;
    -moz-transition: all 0.25s ease;
    transition: all 0.25s ease;
  }

  .react-toggle--checked .react-toggle-thumb {
    left: 27px;
    border-color: ${props => props.theme.toggle.activeColor};
  }
`;

export default ToggleWrapper;
